import React from 'react'
import logo from "../images/kite-34910.png"

const Footer = () => {
    return (
        <div className="footer">
            <ul>
               <li>Shop Address: 19-22, Rodamestry Nagar, Gajularamaram Road, Hyderabad-500055</li>
               <li>Google Maps Link: <a href="https://goo.gl/maps/bzrYmRyrMtYhVi5z5" target="_blank">https://goo.gl/maps/bzrYmRyrMtYhVi5z5</a></li>
            </ul>
        </div>
    )
}

export default Footer
